module.exports = "<div class=\"bot-flow-container\">\r\n  <div class=\"bot-flow-inner-container\">\r\n    <div class=\"tree-view\">\r\n      <ul kendo-tree-view k-options=\"vm.treeViewOptions\" id=\"bot-flow-tree-view\">\r\n      </ul>\r\n    </div>\r\n    <div class=\"graph-container\">\r\n      <h2 class=\"header\">{{vm.header}}</h2>\r\n      <div id=\"bot-flow-graph\" class=\"graph\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/containers/bot-flow/bot-flow.html
 ** module id = 900
 ** module chunks = 0
 **/